const PAGES_PREFIX = '@PAGES';

export const LOAD_DATA = `@PAGES/LOAD_DATA` as const;
export const LOAD_DATA_SUCCESS = `@PAGES/LOAD_DATA_SUCCESS` as const;
export const LOAD_DATA_ERROR = `${PAGES_PREFIX}/LOAD_DATA_ERROR` as const;

export const TOGGLE_FAVORITE_STATUS_SUCCESS = `${PAGES_PREFIX}/TOGGLE_FAVORITE_STATUS_SUCCESS`;

export const RESET_DATA = `${PAGES_PREFIX}/RESET_DATA` as const;
